import { render, staticRenderFns } from "./driver_contacts.vue?vue&type=template&id=135a81b2&"
import script from "./driver_contacts.vue?vue&type=script&lang=js&"
export * from "./driver_contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports